import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';
import ImageFluid from '../../legacy/components/base/ImageFluid';

interface HorizontalCardProps {
  backgroundImage: string;
  description: string;
  alt?: string;
}

export const HorizontalCard = (props: HorizontalCardProps) => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        maxWidth: 360,
        width: '100%',
        height: 'fit-content',
        boxShadow: 'none',
        border: 'none',
        mx: 'auto',
      }}
    >
      <Box flexShrink={1} width={160} borderRadius="0px 0px">
        <ImageFluid
          fluid={props.backgroundImage}
          imgStyle={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            overflow: 'hidden',
          }}
          alt={props.alt ?? ''}
        />
      </Box>

      <CardContent sx={{ p: 1, maxWidth: '247px' }}>
        <Typography variant="body2" fontSize="14px" mt="1em">
          <RawHtml content={props.description} />
        </Typography>
      </CardContent>
    </Card>
  );
};
